/*
 * Desktop - Pdp - Buy Box Secondary CTA Declutter  --  variant: De-emphasize Secondaries
 * Moonshot experiment id: VgZ2vNSEbfYN   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-07-29
 * Audience: DESKTOP   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_d_cta_declutter
 */
MGExp.run('pdp_d_cta_declutter', { name: "Desktop - Pdp - Buy Box Secondary CTA Declutter / De-emphasize Secondaries", platform: 'desktop', target: 'pdp' }, function () {
  !(function () {
    let t = [".msai-cta-hierarchy #polls-platform-pdp-button *"],
      a = ["#pdp-add-to-cart"];
    !(async function (o, i, r, n, p, m) {
      let e = {
        multi_target_selectors: t,
        exclude_from_timeout: a,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(o, i, r, n, p, e, m);
    })(
      [".product-description-column", "#pdp-add-to-cart"],
      ".msai-cta-hierarchy",
      function (t, a) {
        const [o] = a;
        o.classList.add("msai-cta-hierarchy");
      },
      ".msai-cta-hierarchy #trynow-cta-button{background:#ffffff !important;color:#000000 !important;border:1px solid #000000 !important;font-weight:700 !important}.msai-cta-hierarchy #polls-platform-pdp-button{background:none !important;box-shadow:none !important;border:none !important;min-height:0 !important;height:auto !important;padding:0 !important;margin-top:14px !important;margin-bottom:0 !important;text-decoration:underline !important;text-underline-offset:3px !important}.msai-cta-hierarchy #polls-platform-pdp-button *{height:auto !important;min-height:0 !important;max-width:none !important;padding:0 !important;background:transparent !important;background-image:none !important;box-shadow:none !important;border-color:transparent !important}.msai-cta-hierarchy #polls-platform-pdp-button,.msai-cta-hierarchy #polls-platform-pdp-button *{font-family:Raleway,sans-serif !important;font-size:12px !important;font-weight:400 !important;letter-spacing:0.04em !important;color:#6b6b6b !important;line-height:1.4 !important}.msai-cta-hierarchy .single-image-request{margin-top:14px !important}.msai-cta-hierarchy #inventory-locations{margin-top:0 !important}.msai-cta-hierarchy #pdp-add-to-cart{margin-top:4px !important}",
    );
  })();
});
